import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Form, reduxForm } from 'redux-form';
import { propBool, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
import { getFormShowErrors } from '../../../../helpers/form';
import { validateEmail } from '../../../../validate/common';
import SubmitButton from '../../../Ui/Button/SubmitButton';
import PlainInputField from '../../../Ui/Common/Fields/PlainInputField';
const FormIntroduction = (props) => {
    const { handleSubmit, submitting, thisForm } = props;
    const hasShowError = getFormShowErrors(thisForm).length > 0;
    return (_jsxs(Form, Object.assign({ className: 'content-box in-box', onSubmit: handleSubmit }, { children: [_jsx("div", Object.assign({ className: 'honbun' }, { children: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044" })), _jsx("div", Object.assign({ className: 'form form-solution' }, { children: _jsx(PlainInputField, { className: 'input-form-text is-gray', name: 'email', placeholder: 'mailaddres@mailaddres.com', type: 'email', validate: validateEmail }) })), _jsx("div", Object.assign({ className: 'form form-action' }, { children: _jsx(SubmitButton, { className: 'btn btn-primary normal mb2', isDisabled: hasShowError || submitting, isLoading: submitting, text: '上記の内容で送信する' }) }))] })));
};
FormIntroduction.propTypes = {
    handleSubmit: propFunc().isRequired,
    submitting: propBool().isRequired,
    thisForm: propShape().isRequired,
};
const enhance = compose(connect(({ form }) => ({ thisForm: form.FormIntroduction || {} })), reduxForm({ form: 'FormIntroduction' }));
export default enhance(FormIntroduction);
